

import { CityMap } from "./map";
import { Sidebar } from "./sidebar";
import { Widget } from "./widget";

export class Initializer {

    /**
     * Draw a GPX on a map
     * 
     * @param map - The map to draw the GPX on
     * @returns - True if a GPX was found and drawn, false otherwise
     */
    public gpx(map: CityMap): boolean {
        const metaTag = document.querySelector('meta#gpx')
        if (metaTag) {
            const gpx = metaTag.getAttribute('content');
            if (gpx) {
                map.drawGpx(gpx);
            }
            return true;
        }
        return false;
    }

    public permalink(map: CityMap, widget: Widget, sidebar: Sidebar): { success: boolean, filterGroup: string, fitBounds: boolean}{
        const metaMisc = document.querySelector('meta#misc') as HTMLMetaElement;
        const metaAction = document.querySelector('meta#action') as HTMLMetaElement;

        if (metaMisc) {
            const data = JSON.parse(metaMisc.content);
            if (!data) {
                return { success: false, filterGroup: '', fitBounds: false };
            }
            if (data.position && data.position.lat && data.position.lng) {
                map.panTo(data.position.lat, data.position.lng, 19);
            }
            widget.dodgeSidebar(true);
            map.dodgeSidebar(true);
            this.chart(sidebar);
            sidebar.open();
            return { success: true, filterGroup: data.filterGroup, fitBounds: false };
        }

        if (metaAction) {
            const data = JSON.parse(metaAction.content);
            if (!data) {
                return { success: false, filterGroup: '', fitBounds: false };

            }
            if (data.filterGroup) {
                data.filterGroup = data.filterGroup.toLowerCase();
                map.fitBoundsToFilterGroup(data.filterGroup);
                return { success: true, filterGroup: data.filterGroup, fitBounds: true };
            }
        }

        return { success: false, filterGroup: '', fitBounds: false };
    }

    public widget(map: CityMap, sidebar: Sidebar) {
        const widgetButtons = document.querySelectorAll<HTMLElement>('.widget-button');
        widgetButtons.forEach((widgetButton) => {
            widgetButton.addEventListener('click', () => {
                if (widgetButton.dataset.filtergroups) {
                    const filterGroups = widgetButton.dataset.filtergroups.split(',');
                    map.toggleLayers(filterGroups);
                    const sidebarAction = widgetButton.dataset.sidebar;
                    const isFilterActive = widgetButton.classList.contains('active');

                    if (sidebarAction && !isFilterActive) {
                        sidebar.fillWithHtmlFromUrl(`/html-api/sidebar/${sidebarAction}`);
                        if (!sidebar.isOpen()) {
                            sidebar.open();
                        }
                        if (window.history.state !== null) {
                            window.history.replaceState({ sb_out: 1 }, '', `/sidebar/${sidebarAction}`);
                        } else {
                            window.history.pushState({ sb_out: 1 }, '', `/sidebar/${sidebarAction}`);
                        }
                    } else if (sidebarAction && isFilterActive) {
                        window.history.replaceState({ sb_out: 1 }, '', '/');
                    } else if (!sidebarAction && !isFilterActive) {
                        window.history.replaceState({ sb_out: 1 }, '', '/');
                    }

                    widgetButton.classList.toggle('active');
                }
            });
        });
    }

    public chart(sidebar: Sidebar) {
        const sidebarElement = sidebar.getElement();
        const chartCanvases = sidebarElement?.querySelectorAll<HTMLCanvasElement>('.chart') || null;

        if (!chartCanvases) return false;

        const config = {
            type: 'doughnut',
            data: {
                labels: [
                    '< 20 km/h',
                    '20–29 km/h',
                    '30–39 km/h',
                    '40–49 km/h',
                    '≥ 50 km/h',
                ],
                datasets: [{
                    backgroundColor: [
                        '#ffa600',
                        '#003f5c',
                        '#58508d',
                        '#bc5090',
                        '#ff6361',
                    ],
                    hoverOffset: 4,
                    data: [],
                }],
            },
            options: {
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (c: any) {
                                return ` ${c.label}: ${c.parsed} %`;
                            }
                        }
                    },
                    legend: {
                        position: 'right',
                        align: 'center',
                    }
                },
                elements: {
                    point: {
                        radius: 0,
                    }
                }
            }
        };

        chartCanvases.forEach((chartCanvas) => {
            const json = chartCanvas.dataset.speeds;
            if (!json) return;
            const speeds = JSON.parse(json);

            const currentConfig = {
                ...config,
                data: {
                    ...config.data,
                    datasets: [{
                        ...config.data.datasets[0],
                        data: speeds
                    }]
                }
            };

            new Chart(chartCanvas as any, currentConfig);
        });

        return true;
    }
}